module.exports = __webpack_public_path__ + "static/media/gabriel-rufian.1a0034c4.png";